import { defineMessages } from 'react-intl';

export default defineMessages({
    claims: {
        id: 'ri.gateway.views.claims-landing.Claims',
        defaultMessage: 'Claims',
    },
    recentlyViewed: {
        id: 'ri.gateway.views.claims-landing.Recently Viewed',
        defaultMessage: 'Recently Viewed'
    },
    recentlyCreated: {
        id: 'ri.gateway.views.claims-landing.Recently Created',
        defaultMessage: 'Recently Created'
    },
    recentlyReported: {
        id: 'ri.gateway.views.claims-landing.Recently Reported',
        defaultMessage: 'Recently Reported'
    },
    onlineReported: {
        id: 'ri.gateway.views.claims-landing.Claims Reported Online',
        defaultMessage: 'Claims Reported Online'
    },
    onlineSaved: {
        id: 'ri.gateway.views.claims-landing.Continue Incomplete Claims',
        defaultMessage: 'Continue Incomplete Claims'
    },
    lastPageLabel: {
        id: 'ri.gateway.views.claims-landing.Last Page',
        defaultMessage: 'Last Page'
    },
    recentlyReportedHeader: {
        id: 'ri.gateway.views.claims-landing.Claims reported in last 90 days',
        defaultMessage: 'Claims reported in last 90 days'
    },
    onlineReportedHeader: {
        id: 'ri.gateway.views.claims-landing.Claims reported online in last 90 days',
        defaultMessage: 'Claims reported online in last 90 days'
    },
    onlineSavedHeader: {
        id: 'ri.gateway.views.claims-landing.Incomplete claims reported online in the last 30 days',
        defaultMessage: 'Incomplete claims reported online in the last 30 days'
    },
    openClaims: {
        id: 'ri.gateway.views.claims-landing.Open Claims',
        defaultMessage: 'Open Claims'
    },
    closedClaims: {
        id: 'ri.gateway.views.claims-landing.Closed Claims',
        defaultMessage: 'Closed Claims'
    },
    product: {
        id: 'ri.gateway.views.claims-landing.Line',
        defaultMessage: 'Product'
    },
    account: {
        id: 'ri.gateway.views.claims-landing.Account',
        defaultMessage: 'Account'
    },
    claimNumber: {
        id: 'ri.gateway.views.claims-landing.Claim Number',
        defaultMessage: 'Claim Number'
    },
    dateOfInjury: {
        id: 'ri.gateway.views.claims-landing.Date of Injury',
        defaultMessage: 'Date of Loss'
    },
    incurredLoss: {
        id: 'ri.gateway.views.claims-landing.Incurred Loss',
        defaultMessage: 'Incurred Loss'
    },
    lossReported: {
        id: 'ri.gateway.views.claims-landing.Date Reported',
        defaultMessage: 'Date Reported'
    },
    claimantName: {
        id: 'ri.gateway.views.claims-landing.Claimant Name',
        defaultMessage: 'Claimant Name'
    },

    dateOfLoss: {
        id: 'ri.gateway.views.claims-landing.Date of Loss',
        defaultMessage: 'Date of Loss'
    },
    status: {
        id: 'ri.gateway.views.claims-landing.Status',
        defaultMessage: 'Status'
    },
    paid: {
        id: 'ri.gateway.views.claims-landing.Paid',
        defaultMessage: 'Paid'
    },
    netIncurred: {
        id: 'ri.gateway.views.claims-landing.Net Incurred',
        defaultMessage: 'Net Incurred'
    },
    policyNumber: {
        id: 'ri.gateway.views.claims-landing.Policy Number',
        defaultMessage: 'Policy Number'
    },
    noResultFound: {
        id: 'ri.gateway.views.claims-landing.No results found for this filter',
        defaultMessage: 'No results were found for this filter.'
    },
    injuryAnalysis: {
        id: 'gateway.views.account-detail.InjuryAnalysis',
        defaultMessage: 'Claims Analysis'
    },
    lossRuns: { 
        id: 'gateway.views.account-detail.LossRuns',
        defaultMessage: 'Loss Runs'
    },
    injuryDate: {
        id: 'ri.gateway.views.claims-fnol.Injury Date',
        defaultMessage: 'Injury Date'
    },
    reportedDate: {
        id: 'ri.gateway.views.claims-fnol.Date Submitted',
        defaultMessage: 'Date Submitted'
    },
    locationEventOccurred: {
        id: 'ri.gateway.views.claims-fnol.Accident Location',
        defaultMessage: 'Accident Location'
    },
    polEffDate: {
        id: 'ri.gateway.views.claims-fnol.Policy Effective Date',
        defaultMessage: 'Policy Efffective Date'
    },
    fnolView: {
        id: 'ri.gateway.views.claims-fnol.View',
        defaultMessage: 'View'
    },
    claimsExport: {
        id: 'ri.gateway.directives.ClaimSummaryDirective.claim-summary.Export',
        defaultMessage: 'Export'
    },
    draft: {
        id: 'typekey.ClaimState.draft',
        defaultMessage: 'Draft'
    },
    policyNbr: {
        id: 'ri.gateway.views.policyclaims.Policy #',
        defaultMessage: 'Policy #'
    },
    injuryDescription: {
        id: 'ri.gateway.views.policyclaims.Injury Description',
        defaultMessage: 'Injury Description'
    },
    bodyParts: {
        id: 'ri.gateway.views.policyclaims.Body Part',
        defaultMessage: 'Body Part'
    },
    jubDescription: {
        id: 'ri.gateway.views.policyclaims.Job Description',
        defaultMessage: 'Job Description'
    },
    injurylocation: {
        id: 'ri.gateway.views.policyclaims.Injury Location',
        defaultMessage: 'Injury Location'
    }
});
